<template>
  <div class="landing-width-container">
    <router-link :to="{ name: 'Index' }" class="logo"><img :src="require('@/assets/images/logo-ru.svg')" /></router-link>
    <div class="phone-cont">
      <phone />
      <div class="label">Звонок бесплатный</div>
    </div>
    <div class="site-menu-links">
      <router-link :to="{ name: 'Index' }" :class="{ 'active': isMenuPage }"><div class="visible">Меню</div><div class="back">Меню</div></router-link>
      <router-link :to="{ name: 'Conditions' }" active-class="active"><div class="visible">Доставка и оплата</div><div class="back">Доставка и оплата</div></router-link>
      <router-link :to="{ name: 'Restaurants' }" active-class="active"><div class="visible">Рестораны</div><div class="back">Рестораны</div></router-link>
<!--      <router-link :to="{ name: 'About' }" active-class="active"><div class="visible">О доставке</div><div class="back">О доставке</div></router-link>-->
    </div>
    <div class="address-info">
      <b style="font-size: 0.7em;">Санкт-Петербург:</b><br/>
      <span class="addresses">Ул Оптиков 51/1,<br/>Ул Достоевского 6,<br/>Наб Реки Фонтанки 92</span>
    </div>
    <div class="time-info">
      <span class="label">Доставляем еду</span><br/>
      с 10:00 до 2:00
    </div>
    <div class="header-cart" :class="{ 'empty': totalItems === 0, 'order-page': $route.name === 'Order' }">
      <router-link :to="{ name: 'Order' }" class="info-container">
        <svg-inline :src="require('@/assets/icons/cart.svg')" class="header-cart-icon" />
        <div class="ver-line"></div>
        <template v-if="totalItems > 0">
          <div class="total"> {{ totalSum | money }} <rub /></div>
          <div class="ver-line"></div>
          <div class="lines">{{ totalItems }}</div>
        </template>
        <div class="lines" v-else>Корзина пуста</div>
      </router-link>
      <div class="overlay-cart-container">
        <div class="overlay-cart">
          <narrow-cart />
          <router-link
            :to="{ name: 'Order' }"
            class="red button"
            :class="{ 'disabled': totalSum < 800 }"
          >Оформить заказ</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Phone from '/src/components/Phone'
  import NarrowCart from '/src/components/NarrowCart'
  import { mapGetters } from 'vuex'

  export default {
    name: 'DesktopSiteHeader',
    components: {
      Phone,
      NarrowCart
    },
    computed: {
      ...mapGetters({
        totalSum: 'cart/totalSum',
        totalItems: 'cart/totalItems'
      }),
      isMenuPage () {
        return ['Index', 'MenuCategory'].includes(this.$route.name)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/DesktopSiteHeader.vue